import { render, staticRenderFns } from "./AdminScriptViewLayout.vue?vue&type=template&id=defe5040&scoped=true"
import script from "./AdminScriptViewLayout.vue?vue&type=script&lang=js"
export * from "./AdminScriptViewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defe5040",
  null
  
)

export default component.exports